import React from 'react';
import { newDays, weeklyHours } from '../data/hours';
import type { DayHours } from '../types/hours';
import { SkewTag } from './SkewTag';
export function HoursSection() {
  return <section id="hours" aria-labelledby="hours-heading" className="bg-foodGold border-b-4 border-foodMaroon py-20 lg:py-24" data-id="element-125" data-mp="3p195q4u8zbm3">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-126" data-mp="3k0uvqh935rlf">
        <div className="lg:col-span-7" data-id="element-127" data-mp="1v04ecbewu7e">
          <SkewTag tone="orange" shadow="teal" data-id="element-128" data-mp="3u0vlom1gn5yl">
            Big News · Starting Mon Oct 19
          </SkewTag>
          <h2 id="hours-heading" className="font-wide text-4xl sm:text-5xl xl:text-6xl uppercase leading-[0.95] mt-7" data-id="element-129" data-mp="bmw0xixuoc9i">
            Two New Days
            <br data-id="element-130" data-mp="lkk9bbodpia5" />
            <span className="text-foodTeal" data-id="element-131" data-mp="lk0ptqj2ylu0">On the Calendar.</span>
          </h2>
          <p className="text-lg font-medium mt-5 max-w-xl" data-id="element-132" data-mp="glz6r5lnmmij">
            The Food Pavilion is now open Mondays and Wednesdays, serving our
            own menu, on top of weekend pop-ups with some of the Bay Area's
            favorite chefs.
          </p>

          <div className="grid sm:grid-cols-2 gap-8 mt-12" data-id="element-133" data-mp="2feu97p5if9ac">
            {newDays.map(d => <article key={d.day} className="relative bg-white border-4 border-foodTeal pt-10 pb-7 px-6" data-id="element-134" data-mp="2jembxl882l7s">
                <SkewTag as="h3" tone="teal" shadow="gold" className="absolute -top-5 left-5" data-id="element-135" data-mp="2tevb97xigmre">
                  {d.day}
                </SkewTag>
                <p className="font-display font-wide text-3xl font-extrabold uppercase text-foodTeal whitespace-nowrap" data-id="element-136" data-mp="334ola4i08ttj">
                  {d.hours}
                </p>
                <p className="mt-3 text-foodMaroon/85" data-id="element-137" data-mp="3c5medrqwngxc">{d.description}</p>
              </article>)}
          </div>
        </div>

        <div className="lg:col-span-5 bg-foodCream border-4 border-foodMaroon shadow-[8px_8px_0px_0px_#2A1B14]" data-id="element-138" data-mp="3h47gxxtmqcoy">
          <h3 className="font-wide text-3xl uppercase text-foodTeal px-6 pt-6 pb-4 border-b-4 border-foodMaroon" data-id="element-139" data-mp="1gzls45w8gfx6">
            Hours
          </h3>
          <ul className="divide-y-2 divide-foodMaroon/10 px-6" data-id="element-140" data-mp="1qrrff2bji961">
            {weeklyHours.map(d => <li key={d.day} className="flex items-center justify-between gap-4 py-3" data-id="element-141" data-mp="1lzq8zx11zcnx">
                <span className={`font-display font-wide font-extrabold uppercase text-lg ${d.kind === 'closed' ? 'text-foodTaupe' : ''}`} data-id="element-142" data-mp="1zrejxwzkfv3b">
                  {d.day}
                </span>
                <HoursPill entry={d} data-id="element-143" data-mp="29nzokh7ob46m" />
              </li>)}
          </ul>
          <p className="px-6 pt-2 pb-6 text-sm font-semibold italic text-foodTeal" data-id="element-144" data-mp="24p69ikcqn54c">
            Weekend pop-ups with the Bay Area's favorite chefs, every other
            week.
          </p>
        </div>
      </div>
    </section>;
}
function HoursPill({
  entry
}: {
  entry: DayHours;
}) {
  if (entry.kind === 'closed') {
    return <span className="min-w-[8.5rem] text-center rounded-full border-2 border-foodTaupe text-foodTaupe font-bold uppercase text-sm px-4 py-1.5" data-id="element-145" data-mp="2r07npvnewzgv">
        Closed
      </span>;
  }
  const color = entry.kind === 'new' ? 'bg-foodOrange' : 'bg-foodTeal';
  return <span className={`min-w-[8.5rem] text-center rounded-full ${color} text-white font-bold text-sm px-4 py-1.5 whitespace-nowrap`} data-id="element-146" data-mp="2h7s3sssk20tc">
      {entry.hours}
    </span>;
}